import React from 'react';

/** Why Jungle Brick – differentiators. Content from JSON (whyJungleBrick). */
export default function SectionWhyJungleBrick({ content }) {
  const data = content || {};
  const heading = data.heading ?? '';
  const subheading = data.subheading ?? '';
  const points = Array.isArray(data.points) ? data.points : [];
  if (points.length === 0 && !heading) return null;

  return (
    <section className="py-12 sm:py-16" style={{ background: 'var(--jb-section-alt)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="text-center mb-10">
          {heading && <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-text-hero mb-2">{heading}</h2>}
          {subheading && <p className="font-body text-text-sub max-w-xl mx-auto">{subheading}</p>}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {points.map((point, i) => (
            <div
              key={i}
              className="flex gap-4 p-5 rounded-xl border bg-forest-card"
              style={{ borderColor: 'var(--jb-border)' }}
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-display font-bold text-lg text-cyan" style={{ background: 'var(--jb-cyan-dim)' }}>
                {String(i + 1).padStart(2, '0')}
              </div>
              <div>
                {point.title && <h3 className="font-display font-bold text-text-hero mb-1">{point.title}</h3>}
                {point.description && <p className="font-body text-sm text-text-sub leading-relaxed">{point.description}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
